import jwt_decode from "jwt-decode";

/**
 * Initial auth state
 */
export const initAuth = {
    state: false,
    user: 'anonymous',
    roles: [],
    projects: [],
    token: null,
    refreshToken: null
}

/**
 * Function that check validates token by expire time
 * @param {String} token - decoded jwt
 * @returns {int} - seconds to expire token, 0 - expired
 */
export const tokenValidation = token =>{
    if(!token) return 0;
    if(token === "") return 0;
    
    const decodedToken = jwt_decode(token)
    const now = new Date().getTime() / 1000;
    const exp = decodedToken.exp;
    const secondsToExpire = exp - now;

    if(secondsToExpire < 0) return 0;
    
    return exp - now;
}

/**
 * Function that parse JWT and return payload
 * @param {String} token - decoded jwt
 * @returns {Object} - payload
 */
export const tokenParse = token => {
    if(!token) return 0;
    if(token === "") return 0;

    const decodedToken = jwt_decode(token);

    return decodedToken;
}